<template>
  <v-card>
    <v-card-text>
      <form-group>
        <v-flex
          xs12
          md12
          lg12
        >
          <v-tabs
            v-model="tabs"
            slider-color="primary"
          >
            <v-tab>
              Push
            </v-tab>
            <v-tab>
              E-mail
            </v-tab>
            <v-tab>SMS</v-tab>
            <v-tab-item>
              <v-layout
                wrap
                row
              >
                <v-flex
                  sm12
                  md12
                  lg12
                >
                  <input-checkbox
                    v-model="sendPush"
                    label="Enviar push"
                  />
                </v-flex>
                <v-flex
                  sm12
                  md12
                  lg12
                >
                  <input-text
                    v-model="payload.push.titulo"
                    label="Título"
                    v-bind="required(sendPush)"
                  />
                </v-flex>
                <v-flex
                  sm12
                  md12
                  lg12
                >
                  <input-text-area
                    v-model="payload.push.body"
                    label="Mensagem"
                    v-bind="required(sendPush)"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout
                row
                wrap
              >
                <v-flex
                  sm12
                  md12
                  lg12
                >
                  <input-checkbox
                    v-model="sendEmail"
                    label="Enviar e-mail"
                  />
                </v-flex>
                <v-flex
                  sm12
                  md12
                  lg12
                >
                  <input-text
                    v-model="payload.email.titulo"
                    label="Título"
                    v-bind="required(sendEmail)"
                  />
                </v-flex>
                <v-flex
                  sm12
                  md12
                  lg12
                >
                  <input-text-area
                    v-model="payload.email.body"
                    label="Mensagem"
                    v-bind="required(sendEmail)"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout
                row
                wrap
              >
                <v-flex
                  sm12
                  md12
                  lg12
                >
                  <input-checkbox
                    v-model="sendSms"
                    label="Enviar sms"
                  />
                </v-flex>
                <v-flex
                  sm12
                  md12
                  lg12
                >
                  <input-text-area
                    v-model="payload.sms.body"
                    label="Mensagem"
                    v-bind="required(sendSms)"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </form-group>
    </v-card-text>
    <slot />
  </v-card>
</template>

<script>
import FormGroup from 'Support/layout/FormGroup.vue';
import InputText from 'Support/components/inputs/InputText.vue';
import InputTextArea from 'Support/components/inputs/InputTextArea.vue';
import InputCheckbox from 'Support/components/inputs/InputCheckbox.vue';
import rulesMixin from 'Support/mixins/rules-mixin';

export default {
  name: 'CommunicationSetupNotification',
  components: {
    FormGroup, InputText, InputTextArea, InputCheckbox,
  },
  mixins: [rulesMixin],
  data() {
    return {
      tabs: 0,
    };
  },
  computed: {
    payload() {
      return this.communicationData;
    },
    required() {
      return (isRequired, rules = []) => {
        if (isRequired) {
          return {
            required: true,
            rules: [...rules, this.requiredRule],
          };
        }
        return {
          rules,
        };
      };
    },
    proxy() {
      return (key, value) => {
        this.payload.setKeyData(key, value);
      };
    },
    sendSms: {
      get() {
        return this.payload.sendSms;
      },
      set(value) {
        this.proxy('sendSms', value);
      },
    },
    sendEmail: {
      get() {
        return this.payload.sendEmail;
      },
      set(value) {
        this.proxy('sendEmail', value);
      },
    },
    sendPush: {
      get() {
        return this.payload.sendPush;
      },
      set(value) {
        this.proxy('sendPush', value);
      },
    },
  },
  methods: {
    handleTab(tab) {
      this.tabs = tab;
    },
  },
  inject: {
    communicationData: {
      default() {
        return {};
      },
    },
  },
};
</script>
